var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{key:_vm.pauseInteractionKey,staticClass:"pp-interaction-title",class:{
      'pp-rubric-section-text': _vm.interactionMeta.rubric,
      'white--text': _vm.interactionMeta.darkMode
    },attrs:{"role":"heading","aria-level":"2"},domProps:{"innerHTML":_vm._s(_vm.interaction.interactionText)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }